"use client";
import UnsubFormOnly from 'components/common/UnsubFormOnly';

import { useState, useEffect } from "react";
import { useRouter } from "next/router";
import { SiteData, WebsiteTesterProps } from "../../src/types/website-tester";
import { config } from "components/reuseable/screen-canvas-config";
import SEO from 'components/common/SEO';
import * as All from 'data/keywords';
import { Footer1 } from 'components/blocks/footer';

const details = {
    pageName: 'SEOptimist Agency London',
    categories: 'seo, web design',
    description:
        'Transparent, affordable and effective technical SEO services in London for professionals, agencies and enterprise.',
    parentDirectories: ''
};

const WebsiteTester: React.FC<WebsiteTesterProps> = () => {

    const router = useRouter();

    return (
        <>
            <SEO
                title={`Unsubscribe`}
                description={details.description}
                tag={details.categories}
                urlPT={``}
                urlENPT={``}
                url={`${All.HomeList[0].title.toLowerCase().replace(/ /g, '-')}`}
                image={`img/${All.HomeList[0].title.toLowerCase().replace(/ /g, '-')}.jpg`}
            />
            <main className="content-wrapper home">
                <section className="wrapper py-10" style={{ backgroundColor: "#fff" }}>
                    <div className="container">
                        <div className="row gx-md-13 gy-5 align-items-start">
                            <div className="col-lg-12 relative order-1 order-lg-2 pb-15">
                                <div className="row" id="contact">
                                    <div className="col-lg-10 col-xl-8 mx-auto pt-md-11 pt-lg-14">
                                        <h2 className="display-4 mb-3 text-center">Unsubscribe</h2>
                                        <p className="lead text-center mb-8 mx-auto">
                                            Enter your email below and we will remove you from all further communication.
                                        </p>
                                        <div className="text-center">
                                            <UnsubFormOnly />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
            <Footer1
                address={[
                    <>
                        {All.SiteIdentity[0].address1},<br /> {All.SiteIdentity[0].address2},<br />{' '}
                        {All.SiteIdentity[0].address3}
                    </>
                ]}
                email={All.SiteIdentity[0].email}
                phone={All.SiteIdentity[0].phone}
            />
        </>
    );
};


//@ts-expect-error - gen
WebsiteTester.bodyClass = 'transparent';
export default WebsiteTester;
